import { text_mod_35_1, text_mod_35_2 } from "../text/Text.js";

export const module35 = {
  title: "Тема 35. Ашик Омер",
  questions: [
    {
      id: 1,
      subtitle: "ДІЗНАЙСЯ БІЛЬШЕ",
      onlyText: true,
      text: text_mod_35_1,
    },
    {
      id: 2,
      subtitle: "ДОСЛІДЖУЄМО МЕДІА",
      onlyText: true,
      text: text_mod_35_2,
    },
    {
      id: 3,
      question: "За часів ханської держави розвивалася література",
      options: [
        { id: "А", text: "народна" },
        { id: "Б", text: "палацова" },
        { id: "В", text: "ханська" },
        { id: "Г", text: "ашикська" },
      ],
      subtitle: "Тестові питання",
      correctAnswer: "Б",
      isTest: true,
    },
    {
      id: 4,
      question: "Найпоширенішою ашикська поезія є у",
      options: [
        { id: "А", text: "кримських татар" },
        { id: "Б", text: "кримчаків" },
        { id: "В", text: "караїмів" },
        { id: "Г", text: "усіх тюркомовних народів" },
      ],
      correctAnswer: "Г",
      isTest: true,
    },
    {
      id: 5,
      question: "Ашиків називають побратимами українських кобзарів, бо",
      options: [
        { id: "А", text: "вони використовували однакові музичні інструменти." },
        { id: "Б", text: "вони є носіями ідей високої духовності та національної самосвідомості." },
        { id: "В", text: "будова творів, які вони виконували, дуже схожа." },
        { id: "Г", text: "мелодика думи та кошми схожа." },
      ],
      correctAnswer: "Б",
      isTest: true,
    },
    {
      id: 6,
      question: "Який музичний інструмент принесла у сні Ашику Омеру діва?",
      options: [
        { id: "А", text: "саз" },
        { id: "Б", text: "зурну" },
        { id: "В", text: "кавал" },
        { id: "Г", text: "деф" },
      ],
      correctAnswer: "А",
      isTest: true,
    },
    {
      id: 7,
      question: "Останні роки життя Ашик Омер присвятив",
      options: [
        { id: "А", text: "виготовленню музичних інструментів" },
        { id: "Б", text: "спорудженню мечетей" },
        { id: "В", text: "написанню поем" },
        { id: "Г", text: "запису фольклору" },
      ],
      correctAnswer: "Б",
      isTest: true,
    },
    {
      id: 8,
      question: "У рядках “Як риби, ми забилися під камінь / В надії, що врятують море й гори…” Ашик Омер",
      options: [
        { id: "А", text: "передав трагедію рідного народу" },
        { id: "Б", text: "описав красу природи рідного краю" },
        { id: "В", text: "висловив бажання бачити Крим вільним" },
        { id: "Г", text: "використав фольклорні мотиви" },
      ],
      correctAnswer: "А",
      isTest: true,
    },
  ],
};
